export default "__VITE_ASSET__ybNBu3qS__"